/**
 * Gigglz Delivery Wizard (v1)
 * - Single page wizard (mode selection + multi dashboard stub)
 * - Persists state to localStorage
 * - NORMALISES cart so each card is its own line item (qty 1) with a stable _gigglz_uid
 * - Adds Add message / Edit message buttons per card
 * - Routes to /pages/personalise in "update" mode and returns to /pages/delivery
 */
document.addEventListener('DOMContentLoaded', async function () {
  const loadingEl = document.getElementById('dw-loading');
  const emptyEl = document.getElementById('dw-empty');
  const mainEl = document.getElementById('dw-main');
  const continueBtn = document.getElementById('dw-continue');

  const messageGateEl = document.getElementById('dw-message-gate');
  const messageGateTextEl = document.getElementById('dw-message-gate-text');
  const messageGateListEl = document.getElementById('dw-message-gate-list');
  const messageGateAddBtn = document.getElementById('dw-message-gate-add');
  const messageGateContinueBtn = document.getElementById('dw-message-gate-continue');

  // Editor modal (Step 5)
  const editorEl = document.getElementById('dw-editor');
  const editorForm = document.getElementById('dw-editor-form');
  const editorErrorEl = document.getElementById('dw-editor-error');
  const editorCardIdEl = document.getElementById('dw-editor-cardid');

  const scheduleDateRow = document.getElementById('dw-schedule-date-row');
  const scheduleDateEl = document.getElementById('dw-schedule-date');
  const scheduleHelpEl = document.getElementById('dw-schedule-help');
  const scheduleToggleEl = document.getElementById('dw-schedule-toggle');
  const scheduleTypeInputEl = document.getElementById('dw-schedule-type-input');

  const addressSearchHostEl = document.getElementById('dw-address-search-host');
  const addressManualToggleEl = document.getElementById('dw-address-manual-toggle');
  const addressLookupMessageEl = document.getElementById('dw-address-lookup-message');
  const addressFieldsWrapEl = document.getElementById('dw-address-fields');
  const postcodeLookupRowEl = document.getElementById('dw-postcode-lookup-row');
  const dividerEl = editorForm ? editorForm.querySelector('.dw-divider') : null;

  const savedWrap = document.getElementById('dw-saved-addresses');
  const savedSelect = document.getElementById('dw-saved-address-select');
  const savedMessageEl = document.getElementById('dw-saved-address-message');

  const pcFindBtn = document.getElementById('dw-postcode-find');
  const pcInputEl = document.getElementById('dw-postcode-lookup');
  const pcResultsWrap = document.getElementById('dw-postcode-results');
  const pcSelectEl = document.getElementById('dw-postcode-select');

  // Send-to toggle elements (replaces radios)
  const sendToggleEl = document.getElementById('dw-send-toggle');
  const sendToInputEl = document.getElementById('dw-send-to-input');

  function updateDeliveryKeyboardSpace() {
    const viewport = window.visualViewport;

    if (!viewport) {
      document.documentElement.style.setProperty(
        '--dw-keyboard-space',
        '0px'
      );
      return;
    }

    const keyboardSpace = Math.max(
      0,
      Math.round(
        window.innerHeight -
        viewport.height -
        viewport.offsetTop
      )
    );

    document.documentElement.style.setProperty(
      '--dw-keyboard-space',
      `${keyboardSpace}px`
    );
  }

  if (window.visualViewport) {
    window.visualViewport.addEventListener(
      'resize',
      updateDeliveryKeyboardSpace
    );

    window.visualViewport.addEventListener(
      'scroll',
      updateDeliveryKeyboardSpace
    );
  }

  window.addEventListener(
    'resize',
    updateDeliveryKeyboardSpace
  );

  updateDeliveryKeyboardSpace();

  // Views inside dw-main
  const modeGrid = mainEl ? mainEl.querySelector('.dw-mode-grid') : null;
  const dashboardEl = document.getElementById('dw-dashboard');
  const cardsEl = document.getElementById('dw-cards');
  const questionEls = mainEl ? mainEl.querySelectorAll('.dw-question') : [];
  const modeQuestionEl = questionEls && questionEls.length > 0 ? questionEls[0] : null;
  const dashboardQuestionEl = questionEls && questionEls.length > 1 ? questionEls[1] : null;
  const customerLoggedIn = mainEl && mainEl.dataset.customerLoggedIn === 'true';
  const deliveryDateOptionsUrl = (mainEl && mainEl.dataset && mainEl.dataset.deliveryDateOptionsUrl)
    ? String(mainEl.dataset.deliveryDateOptionsUrl)
    : '/apps/gigglz/delivery-date-options';
  const deliveryLeadWorkingDaysDefault = Number((mainEl && mainEl.dataset && mainEl.dataset.deliveryLeadWorkingDays) || 6) || 6;

  // One state object for the whole wizard
  const STATE_KEY = 'gigglz_delivery_state_v1';
  const DELIVERY_DATE_OPTIONS_CACHE_KEY = 'gigglz_delivery_date_options_v1';

  // used to avoid normalising repeatedly in a loop
  const NORMALISE_KEY = 'gigglz_cart_normalised_v1';

  // Personalise-message localStorage keys (must match personalise-message.js)
  const LS = {
    SOURCE: 'gigglz_personalise_source',
    RETURN_TO: 'gigglz_personalise_return_to',
    LINE_KEY: 'gigglz_personalise_line_key',
    SCROLL_TO_DASHBOARD: 'gigglz_delivery_scroll_to_dashboard'
  };

  // Line item properties we care about
  const PROP = {
    UID: '_gigglz_uid',
    ITEM_TYPE: '_gigglz_item_type',
    PACK_SIZE: '_gigglz_pack_size',
    PRODIGI_SKU: '_gigglz_prodigi_sku',
    RATE_PROFILE: '_gigglz_rate_profile',
    FRONT_ASSET_KEY: '_gigglz_front_asset_key',
    BACK_ASSET_KEY: '_gigglz_back_asset_key',
    FRONT_SOURCE: '_gigglz_front_source',
    CUSTOM_DESIGN_ID: '_gigglz_custom_design_id',
    SEND_TO: '_gigglz_send_to',
    FULL_NAME: '_gigglz_full_name',
    ADDRESS1: '_gigglz_address1',
    ADDRESS2: '_gigglz_address2',
    CITY: '_gigglz_city',
    COUNTY: '_gigglz_county',
    POSTCODE: '_gigglz_postcode',
    COUNTRY: '_gigglz_country',
    SPEED: '_gigglz_speed',
    SCHEDULE_TYPE: '_gigglz_schedule_type',
    SCHEDULE_DATE: '_gigglz_schedule_date',
    MESSAGE_PRESENT: '_gigglz_message_present',

    DELIVERY_TO: 'Deliver to',
    DELIVERY_METHOD: 'Delivery method',
    MESSAGE: '_gigglz_message',
    FONT: '_gigglz_font',
    SIZE: '_gigglz_text_size'
  };

  // Pack helpers: read raw line properties and detect pack lines.
  function getItemProp(item, name) {
    const props = item && item.properties ? item.properties : {};
    const v = props[name];
    if (v == null) return '';
    return (typeof v === 'string') ? v.trim() : String(v).trim();
  }
  function isPackItem(item) {
    return getItemProp(item, PROP.ITEM_TYPE) === 'card_pack';
  }

  // Delivery methods (step 1)
  const DELIVERY_METHODS = ['budget', 'standard', 'express', 'overnight'];
  const DEFAULT_DELIVERY_METHOD = 'standard';
  const DELIVERY_METHOD_LABELS = {
    budget: 'Budget',
    standard: 'Standard',
    express: 'Express',
    overnight: 'Overnight'
  };

  const addressLookupState = {
    widget: null,
    initialised: false,
    selectedDisplay: ''
  };

  // Always keep a single "source of truth" reference
  let currentState = null;
  let currentScheduleDateOptions = null;
  let savedAddressesLoaded = false;
  let savedAddressesCache = [];
  let savedAddressesPromise = null;
  let currentSavedAddressId = null;

  function isSingleCardState(state) {
    return !!(state && Array.isArray(state.cards) && state.cards.length === 1);
  }

  function isAllPacksState(state) {
    var cards = state && Array.isArray(state.cards) ? state.cards : [];
    return cards.length > 0 && cards.every(function (c) { return !!(c && c.isPack); });
  }

  function isSharedSingleAddressMode(state) {
    return !!(state && Array.isArray(state.cards) && state.cards.length > 1 && state.mode === 'single');
  }

  function allowSendToMeForState(state) {
    return !!state;
  }

  function getDefaultSendToForState(state) {
    return isSharedSingleAddressMode(state) ? 'me' : 'them';
  }

  function setModeSelectionVisible(show) {
    if (modeQuestionEl) modeQuestionEl.hidden = !show;
    if (modeGrid) modeGrid.hidden = !show;
  }

  function reconcileModeWithCardCount(state) {
    if (!state || !Array.isArray(state.cards)) return state;

    if (state.cards.length === 1) {
      state.mode = 'single';
    } else if (state.cards.length > 1 && isAllPacksState(state)) {
      // Every card is a pack; packs can only go to the buyer's one address, so
      // there is no address choice to make. Use one shared address and skip the
      // single/multiple question.
      state.mode = 'single';
    } else if (state.cards.length > 1 && state.mode !== 'single' && state.mode !== 'multi') {
      state.mode = null;
    }

    return state;
  }

  function hasAnyCompletedCards(state) {
    const cards = state && Array.isArray(state.cards) ? state.cards : [];
    return cards.some(card => card.complete === true);
  }

  function startSingleCardFlow(state, opts) {
    const options = opts || {};
    if (!isSingleCardState(state)) return;

    state.mode = 'single';
    saveState(state);
    currentState = loadState() || state;

    updateQuestionTextForState(currentState);
    setModeSelectionVisible(false);
    showDashboard(currentState);

    const onlyCard = currentState.cards[0];
    const shouldAutoOpen = options.autoOpenIfIncomplete !== false && onlyCard && !onlyCard.complete;

    if (shouldAutoOpen) {
      openEditor(onlyCard, { allowSendToMe: allowSendToMeForState(currentState) });
    }
  }

  function updateQuestionTextForState(state) {
    if (dashboardQuestionEl) {
      if (isSingleCardState(state)) {
        dashboardQuestionEl.textContent = 'Enter delivery details';
      } else if (isSharedSingleAddressMode(state)) {
        dashboardQuestionEl.textContent = 'Set delivery details for all cards';
      } else {
        dashboardQuestionEl.textContent = 'Set delivery details for each card';
      }
    }
  }

  function loadState() {
    try {
      const raw = localStorage.getItem(STATE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function saveState(state) {
    localStorage.setItem(STATE_KEY, JSON.stringify(state));
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function makeUid() {
    return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  }


function formatLocalDateAsIso(date) {
  if (!(date instanceof Date)) return '';
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function parseIsoDateToLocalDate(value) {
  const text = String(value || '').trim();
  if (!/^\d{4}-\d{2}-\d{2}$/.test(text)) return null;

  const parts = text.split('-').map(Number);
  const date = new Date(parts[0], parts[1] - 1, parts[2]);
  if (Number.isNaN(date.getTime())) return null;
  return date;
}

function todayLocalDate() {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate());
}

function isWeekendDate(date) {
  if (!(date instanceof Date)) return false;
  const day = date.getDay();
  return day === 0 || day === 6;
}

function getCachedBankHolidaySet() {
  const cached = loadCachedDeliveryDateOptions();
  const holidays = cached && Array.isArray(cached.bank_holidays) ? cached.bank_holidays : [];
  return new Set(holidays);
}

function isWorkingDayDate(date, bankHolidaySet) {
  if (!(date instanceof Date)) return false;
  if (isWeekendDate(date)) return false;
  return !(bankHolidaySet && bankHolidaySet.has(formatLocalDateAsIso(date)));
}

function addWorkingDaysLocal(startDate, workingDays, bankHolidaySet) {
  const current = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
  let added = 0;

  while (added < Math.max(Number(workingDays) || 0, 0)) {
    current.setDate(current.getDate() + 1);
    if (isWorkingDayDate(current, bankHolidaySet)) {
      added += 1;
    }
  }

  return current;
}

function loadCachedDeliveryDateOptions() {
  try {
    const raw = localStorage.getItem(DELIVERY_DATE_OPTIONS_CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch (e) {
    return null;
  }
}

function saveCachedDeliveryDateOptions(options) {
  try {
    localStorage.setItem(DELIVERY_DATE_OPTIONS_CACHE_KEY, JSON.stringify(options));
  } catch (e) {}
}

function buildFallbackDeliveryDateOptions(reason) {
  const cached = loadCachedDeliveryDateOptions();
  const bankHolidays = cached && Array.isArray(cached.bank_holidays) ? cached.bank_holidays : [];
  const bankHolidaySet = new Set(bankHolidays);
  const leadWorkingDays = (cached && Number(cached.lead_working_days)) || deliveryLeadWorkingDaysDefault;
  const earliestDate = addWorkingDaysLocal(todayLocalDate(), leadWorkingDays, bankHolidaySet);

  return {
    ok: true,
    speed: normaliseDeliveryMethod(getVal('dw-speed')),
    country: 'GB',
    lead_working_days: leadWorkingDays,
    earliest_delivery_date: formatLocalDateAsIso(earliestDate),
    bank_holidays: bankHolidays,
    message: bankHolidays.length
      ? `Choose a delivery date at least ${leadWorkingDays} working days away. Weekends and England and Wales bank holidays are unavailable.`
      : `Live date checks are temporarily unavailable. Please choose a delivery date at least ${leadWorkingDays} working days away.`,
    source: bankHolidays.length ? 'cached_fallback' : 'local_fallback',
    fallback_reason: String(reason || '').trim()
  };
}

function normaliseDeliveryDateOptions(payload) {
  const bankHolidays = Array.isArray(payload && payload.bank_holidays) ? payload.bank_holidays : [];
  const leadWorkingDays = Number(payload && payload.lead_working_days) || deliveryLeadWorkingDaysDefault;
  const earliest = String(payload && payload.earliest_delivery_date || '').trim();
  const parsedEarliest = parseIsoDateToLocalDate(earliest);
  const safeEarliest = parsedEarliest
    ? earliest
    : formatLocalDateAsIso(addWorkingDaysLocal(todayLocalDate(), leadWorkingDays, new Set(bankHolidays)));

  return {
    ok: true,
    speed: normaliseDeliveryMethod(payload && payload.speed),
    country: String(payload && payload.country || 'GB').trim().toUpperCase(),
    lead_working_days: leadWorkingDays,
    earliest_delivery_date: safeEarliest,
    bank_holidays: bankHolidays,
    message: String(payload && payload.message || '').trim(),
    source: String(payload && payload.holiday_source || payload && payload.source || 'api').trim()
  };
}

function setScheduleHelpText(message) {
  if (!scheduleHelpEl) return;
  scheduleHelpEl.textContent = String(message || '').trim() || `Choose a delivery date at least ${deliveryLeadWorkingDaysDefault} working days away.`;
}

function applyScheduleDateOptions(options) {
  const resolved = normaliseDeliveryDateOptions(options || {});
  currentScheduleDateOptions = resolved;
  saveCachedDeliveryDateOptions(resolved);

  if (scheduleDateEl) {
    scheduleDateEl.min = resolved.earliest_delivery_date;
    scheduleDateEl.dataset.bankHolidays = JSON.stringify(resolved.bank_holidays || []);
    scheduleDateEl.dataset.leadWorkingDays = String(resolved.lead_working_days || deliveryLeadWorkingDaysDefault);
    scheduleDateEl.dataset.optionsSource = resolved.source || 'api';

    if (!scheduleDateEl.value && scheduleTypeInputEl && scheduleTypeInputEl.value === 'date') {
      scheduleDateEl.value = resolved.earliest_delivery_date;
    }
  }

  setScheduleHelpText(
    resolved.message ||
    `Choose a delivery date at least ${resolved.lead_working_days || deliveryLeadWorkingDaysDefault} working days away.`
  );

  return resolved;
}

async function fetchDeliveryDateOptions(speed) {
  const method = normaliseDeliveryMethod(speed || DEFAULT_DELIVERY_METHOD);
  const url = `${deliveryDateOptionsUrl}?country=GB&speed=${encodeURIComponent(method)}`;
  const res = await fetch(url, {
    method: 'GET',
    credentials: 'same-origin',
    headers: { Accept: 'application/json' }
  });

  if (!res.ok) {
    throw new Error(`Delivery date options request failed: ${res.status}`);
  }

  const payload = await res.json();
  return applyScheduleDateOptions(payload);
}

async function ensureScheduleDateOptions(force) {
  const shouldForce = force === true;
  const speed = normaliseDeliveryMethod(getVal('dw-speed') || DEFAULT_DELIVERY_METHOD);

  if (!shouldForce && currentScheduleDateOptions && currentScheduleDateOptions.speed === speed) {
    return applyScheduleDateOptions(currentScheduleDateOptions);
  }

  try {
    return await fetchDeliveryDateOptions(speed);
  } catch (err) {
    console.warn('Could not load delivery date options', err);
    return applyScheduleDateOptions(buildFallbackDeliveryDateOptions(err && err.message ? err.message : 'request_failed'));
  }
}

function getCurrentScheduleBankHolidaySet() {
  if (currentScheduleDateOptions && Array.isArray(currentScheduleDateOptions.bank_holidays)) {
    return new Set(currentScheduleDateOptions.bank_holidays);
  }

  return getCachedBankHolidaySet();
}

function validateScheduleDateValue(dateValue) {
  const text = String(dateValue || '').trim();
  const parsed = parseIsoDateToLocalDate(text);
  if (!parsed) {
    return { ok: false, message: 'Please choose a delivery date.' };
  }

  const options = currentScheduleDateOptions || buildFallbackDeliveryDateOptions('validate_without_live_options');
  const earliest = parseIsoDateToLocalDate(options.earliest_delivery_date);
  const bankHolidaySet = new Set(options.bank_holidays || []);

  if (earliest && parsed < earliest) {
    return {
      ok: false,
      message: `Please choose ${options.earliest_delivery_date} or later.`
    };
  }

  if (!isWorkingDayDate(parsed, bankHolidaySet)) {
    return {
      ok: false,
      message: 'Please choose a working day that is not a weekend or bank holiday.'
    };
  }

  return { ok: true, message: '' };
}

async function refreshScheduleDateOptionsForEditor(force) {
  if (!scheduleDateEl || !scheduleTypeInputEl || scheduleTypeInputEl.value !== 'date') {
    setScheduleHelpText(`Choose a delivery date at least ${deliveryLeadWorkingDaysDefault} working days away.`);
    return null;
  }

  return ensureScheduleDateOptions(force === true);
}

  function normalisePostcode(pc) {
    return String(pc || '')
      .trim()
      .toUpperCase()
      .replace(/\s+/g, ' ')
      .replace(/[^A-Z0-9 ]/g, '');
  }

  // Basic UK-ish postcode check for MVP (not perfect, but catches obvious mistakes)
  function isProbablyUKPostcode(pc) {
    const compact = normalisePostcode(pc).replace(/\s/g, '');
    return /^[A-Z0-9]{2,4}[0-9][A-Z0-9]{2}$/.test(compact);
  }

  function titleCase(s) {
    const v = String(s || '');
    return v ? v.charAt(0).toUpperCase() + v.slice(1) : v;
  }

  function normaliseDeliveryMethod(value) {
    const v = String(value || '').trim().toLowerCase();
    return DELIVERY_METHODS.includes(v) ? v : DEFAULT_DELIVERY_METHOD;
  }

  function getDeliveryMethodLabel(value) {
    const method = normaliseDeliveryMethod(value);
    return DELIVERY_METHOD_LABELS[method] || titleCase(method);
  }

  // "From" prices shown to the customer. Must match aws/shared/pricing.py
  // (first-card price per rate profile; A4 matches 7x5).
  //   dir  = posted direct to the recipient (7x5_dir / a4_dir)
  //   bla  = sent to the buyer to hand over (7x5_bla / a4_bla)
  //   pack = card pack, always sent to the buyer (7x5_pack)
  const DELIVERY_FROM_PENCE = {
    dir: { budget: 145, standard: 195, express: 570, overnight: 1075 },
    bla: { budget: 185, standard: 235, express: 645, overnight: 1075 },
    pack: { budget: 249, standard: 299, express: 799, overnight: 1299 }
  };

  const DELIVERY_METHOD_DAYS = {
    budget: '2–3 days',
    standard: '1–2 days',
    express: '1–2 days tracked',
    overnight: 'next day tracked'
  };

  // Shorter wording used in the speed dropdown (matches the Liquid markup).
  const DELIVERY_OPTION_DAYS = {
    budget: '2–3 days',
    standard: '1–2 days',
    express: '1–2 days',
    overnight: 'next day'
  };

  function formatPence(pence) {
    return `£${(Number(pence) / 100).toFixed(2)}`;
  }

  function getPriceHintKey(sendTo, isPack) {
    if (isPack) return 'pack';
    return sendTo === 'me' ? 'bla' : 'dir';
  }

  function getDeliveryPriceHint(method, key) {
    const table = DELIVERY_FROM_PENCE[key] || DELIVERY_FROM_PENCE.dir;
    const days = DELIVERY_METHOD_DAYS[method];
    if (!days || table[method] == null) return '';
    return `${days}, from ${formatPence(table[method])}`;
  }

  // Rewrite the speed dropdown labels for who the card is going to.
  function updateSpeedOptionLabels(key) {
    const select = document.getElementById('dw-speed');
    if (!select) return;
    const table = DELIVERY_FROM_PENCE[key] || DELIVERY_FROM_PENCE.dir;
    Array.from(select.options).forEach(option => {
      const method = normaliseDeliveryMethod(option.value);
      if (table[method] == null || !DELIVERY_OPTION_DAYS[method]) return;
      option.textContent = `${getDeliveryMethodLabel(method)} · ${DELIVERY_OPTION_DAYS[method]} · from ${formatPence(table[method])}`;
    });
  }

  function buildPublicDeliveryMethod(delivery, card) {
    const method = normaliseDeliveryMethod(delivery && delivery.speed);
    const label = getDeliveryMethodLabel(method);
    const isPack = !!(card && card.isPack);
    const hint = getDeliveryPriceHint(method, getPriceHintKey(delivery && delivery.sendTo, isPack));

    return hint ? `${label} (${hint})` : label;
  }

  function getCardSizeLabel(card) {
    const raw = String(card && card.variantTitle ? card.variantTitle : '').trim();
    if (!raw || raw === 'Default Title') return '';
    return raw;
  }

  function cleanConfigString(value, fallback) {
    const v = String(value == null ? '' : value).trim();
    return v || String(fallback || '').trim();
  }

  function getMainDataAttr(name) {
    return mainEl ? mainEl.getAttribute(name) : '';
  }

  function readProdigiSkuConfig() {
    return {
      card7x5Dir: cleanConfigString(
        getMainDataAttr('data-prodigi-sku-card-7x5-dir'),
        'GLOBAL-GRE-GLOS-7X5-DIR'
      ),
      card7x5Bla: cleanConfigString(
        getMainDataAttr('data-prodigi-sku-card-7x5-bla'),
        'GLOBAL-GRE-GLOS-7X5-BLA'
      ),
      cardA4Dir: cleanConfigString(
        getMainDataAttr('data-prodigi-sku-card-a4-dir'),
        'GLOBAL-GRE-GLOS-A4-DIR'
      ),
      cardA4Bla: cleanConfigString(
        getMainDataAttr('data-prodigi-sku-card-a4-bla'),
        'GLOBAL-GRE-GLOS-A4-BLA'
      )
    };
  }

  function getCardSearchText(card) {
    return `${card && card.variantTitle ? card.variantTitle : ''} ${card && card.title ? card.title : ''}`.toLowerCase();
  }

  function getCardSizeKey(card) {
    const raw = getCardSearchText(card);

    if (raw.includes('a4') || raw.includes('jumbo')) {
      return 'a4';
    }

    return '7x5';
  }

  function getCardSendKey(card) {
    return card && card.delivery && card.delivery.sendTo === 'me' ? 'bla' : 'dir';
  }

  function getCardRateProfileKey(card) {
    return `${getCardSizeKey(card)}_${getCardSendKey(card)}`;
  }

  function getProdigiSku(card) {
    const cfg = readProdigiSkuConfig();
    const sizeKey = getCardSizeKey(card);
    const sendKey = getCardSendKey(card);

    if (sizeKey === 'a4') {
      return sendKey === 'bla' ? cfg.cardA4Bla : cfg.cardA4Dir;
    }

    return sendKey === 'bla' ? cfg.card7x5Bla : cfg.card7x5Dir;
  }

    function applyProdigiMetadata(card) {
    if (!card) return card;
    if (card.isPack) {
      card.prodigiSku = String(card.packSku || '').trim() || 'GLOBAL-GRE-GLOS-7X5-BLA-10';
      card.prodigiRateProfile = String(card.packRateProfile || '').trim() || '7x5_pack';
      return card;
    }
    card.prodigiSku = getProdigiSku(card);
    card.prodigiRateProfile = getCardRateProfileKey(card);
    return card;
  }

  function buildPublicDeliveryTo(delivery) {
    const address = delivery && delivery.address ? delivery.address : {};
    const fullName = String(address.fullName || '').trim();
    const line1 = String(address.line1 || '').trim();
    const postcode = normalisePostcode(address.postcode || '');

    return [fullName, line1, postcode].filter(Boolean).join(', ');
}

function getCheckoutCardLabel(card, index) {
  const title = String(card && card.title ? card.title : '').trim();
  return title || `Card ${Number(index) + 1}`;
}

function normaliseCheckoutCompareValue(value) {
  return String(value == null ? '' : value).trim();
}

function buildCheckoutStateIndex(state) {
  if (!state || !Array.isArray(state.cards) || state.cards.length === 0) {
    throw new Error('No cards were found in the delivery wizard. Please return to your basket and try again.');
  }

  const byUid = new Map();

  state.cards.forEach((card, index) => {
    const label = getCheckoutCardLabel(card, index);
    const uid = String(card && card.id ? card.id : '').trim();

    if (!uid) {
      throw new Error(`${label} is missing its Gigglz card ID. Please return to your basket and try again.`);
    }

    if (byUid.has(uid)) {
      throw new Error(`Two cards have the same Gigglz card ID (${uid}). Please return to your basket and try again.`);
    }

    if (!card || card.complete !== true) {
      throw new Error(`Delivery details have not been confirmed for “${label}”. Please open that card and confirm them before payment.`);
    }

    const deliveryCheck = validateDelivery(card.delivery);
    if (!deliveryCheck.ok) {
      throw new Error(
        `Delivery details for “${label}” are incomplete:\n- ${deliveryCheck.errors.join('\n- ')}`
      );
    }

    applyProdigiMetadata(card);

    const hasFrontArtwork = String(card.frontAssetKey || '').trim() || String(card.frontSource || '').trim().toLowerCase() === 'custom';
    if (!hasFrontArtwork || !String(card.backAssetKey || '').trim()) {
      throw new Error(`“${label}” is missing its artwork details. Please remove and re-add the card.`);
    }

    if (!String(card.prodigiSku || '').trim() || !String(card.prodigiRateProfile || '').trim()) {
      throw new Error(`“${label}” is missing its production or delivery profile. Please review its delivery details.`);
    }

    byUid.set(uid, card);
  });

  return byUid;
}

function buildCheckoutCartIndex(cart) {
  const items = cart && Array.isArray(cart.items) ? cart.items : [];

  if (items.length === 0) {
    throw new Error('Your basket is empty. Please return to the basket and add your cards again.');
  }

  const byUid = new Map();

  items.forEach((item, index) => {
    const line = (item && item.__line) || index + 1;
    const uid = String(getUid(item) || '').trim();

    if (!uid) {
      throw new Error(`Basket line ${line} is missing its Gigglz card ID. Please return to your basket and try again.`);
    }

    if (byUid.has(uid)) {
      throw new Error(`Your basket contains duplicate Gigglz card IDs (${uid}). Please return to your basket and try again.`);
    }

    const lineQty = Number(item.quantity) || 0;
    if (isPackItem(item)) {
      if (lineQty < 1) {
        throw new Error('Your basket changed while delivery details were being prepared. Please return to the basket and try again.');
      }
    } else if (lineQty !== 1) {
      throw new Error('Your basket changed while delivery details were being prepared. Please return to the basket and try again.');
    }

    byUid.set(uid, { item, line });
  });

  return byUid;
}

function assertCheckoutStateMatchesCart(state, cart) {
  const stateByUid = buildCheckoutStateIndex(state);
  const cartByUid = buildCheckoutCartIndex(cart);
  const cartItems = Array.isArray(cart && cart.items) ? cart.items : [];
  const itemCount = Number(cart && cart.item_count);

  const expectedItemCount = cartItems.reduce(
    (total, item) => total + (isPackItem(item) ? (Number(item.quantity) || 0) : 1),
    0
  );

  if (cartItems.length !== stateByUid.size || (Number.isFinite(itemCount) && itemCount !== expectedItemCount)) {
    throw new Error('Your basket changed after the delivery page was opened. Please review the cards and delivery details again.');
  }

  stateByUid.forEach((card, uid) => {
    if (!cartByUid.has(uid)) {
      throw new Error(`The basket line for “${card.title || 'a card'}” could not be found. Please return to your basket and try again.`);
    }
  });

  cartByUid.forEach((entry, uid) => {
    if (!stateByUid.has(uid)) {
      throw new Error('A card in your basket does not have matching delivery state. Please review the delivery details again.');
    }
  });

  return { stateByUid, cartByUid };
}

function buildGigglzCardProperties(existingProps, card) {
  if (!card) {
    throw new Error('A delivery-state card could not be found. Please review your basket and try again.');
  }

  const uid = String(card.id || '').trim();
  if (!uid) {
    throw new Error('A card is missing its Gigglz card ID. Please return to your basket and try again.');
  }

  const deliveryCheck = validateDelivery(card.delivery);
  if (!deliveryCheck.ok) {
    throw new Error(
      `Delivery details for “${card.title || 'this card'}” are incomplete:\n- ${deliveryCheck.errors.join('\n- ')}`
    );
  }

  applyProdigiMetadata(card);

  const delivery = card.delivery;
  const address = delivery.address;
  const schedule = delivery.schedule || { type: 'asap' };
  const props = Object.assign({}, existingProps || {});

  props[PROP.UID] = uid;
  props[PROP.ITEM_TYPE] = card.isPack ? 'card_pack' : 'card';
  props[PROP.PRODIGI_SKU] = String(card.prodigiSku || '').trim();
  props[PROP.RATE_PROFILE] = String(card.prodigiRateProfile || '').trim();
  props[PROP.FRONT_ASSET_KEY] = String(card.frontAssetKey || '').trim();
  props[PROP.BACK_ASSET_KEY] = String(card.backAssetKey || '').trim();
  props[PROP.SEND_TO] = card.isPack ? 'me' : delivery.sendTo;
  if (card.isPack) {
    props[PROP.PACK_SIZE] = String(card.packSize || '').trim() || '10';
  }
  props[PROP.FULL_NAME] = String(address.fullName || '').trim();
  props[PROP.ADDRESS1] = String(address.line1 || '').trim();
  props[PROP.ADDRESS2] = String(address.line2 || '').trim();
  props[PROP.CITY] = String(address.city || '').trim();
  props[PROP.COUNTY] = String(address.county || '').trim();
  props[PROP.POSTCODE] = normalisePostcode(address.postcode || '');
  props[PROP.COUNTRY] = 'GB';
  props[PROP.SPEED] = normaliseDeliveryMethod(delivery.speed);
  props[PROP.SCHEDULE_TYPE] = schedule.type === 'date' ? 'date' : 'asap';
  props[PROP.SCHEDULE_DATE] = schedule.type === 'date' ? String(schedule.date || '').trim() : '';
  props[PROP.MESSAGE_PRESENT] = card.hasMessage ? 'true' : 'false';
  props[PROP.DELIVERY_TO] = buildPublicDeliveryTo(delivery);
  props[PROP.DELIVERY_METHOD] = buildPublicDeliveryMethod(delivery, card);

  return props;
}

const CHECKOUT_MANAGED_PROPERTY_KEYS = [
  PROP.UID,
  PROP.ITEM_TYPE,
  PROP.PRODIGI_SKU,
  PROP.RATE_PROFILE,
  PROP.FRONT_ASSET_KEY,
  PROP.BACK_ASSET_KEY,
  PROP.SEND_TO,
  PROP.FULL_NAME,
  PROP.ADDRESS1,
  PROP.ADDRESS2,
  PROP.CITY,
  PROP.COUNTY,
  PROP.POSTCODE,
  PROP.COUNTRY,
  PROP.SPEED,
  PROP.SCHEDULE_TYPE,
  PROP.SCHEDULE_DATE,
  PROP.MESSAGE_PRESENT,
  PROP.DELIVERY_TO,
  PROP.DELIVERY_METHOD
];

function verifyPersistedCheckoutCart(state, cart) {
  const { stateByUid, cartByUid } = assertCheckoutStateMatchesCart(state, cart);

  stateByUid.forEach((card, uid) => {
    const entry = cartByUid.get(uid);
    if (!entry) {
      throw new Error(`The saved basket line for “${card.title || 'a card'}” could not be found.`);
    }

    const actualProps = entry.item.properties || {};
    const expectedProps = buildGigglzCardProperties(actualProps, card);

    CHECKOUT_MANAGED_PROPERTY_KEYS.forEach((key) => {
      const actual = normaliseCheckoutCompareValue(actualProps[key]);
      const expected = normaliseCheckoutCompareValue(expectedProps[key]);

      if (actual !== expected) {
        throw new Error(
          `Delivery details were not saved correctly for “${card.title || 'a card'}” (${key}). Please try again.`
        );
      }
    });
  });

  return cart;
}

async function persistWizardToCart(state) {
  const stateByUid = buildCheckoutStateIndex(state);

  for (const [uid, card] of stateByUid.entries()) {
    const latestCart = await getCart();
    const { cartByUid } = assertCheckoutStateMatchesCart(state, latestCart);
    const currentEntry = cartByUid.get(uid);

    if (!currentEntry) {
      throw new Error(`The basket line for “${card.title || 'a card'}” could not be found. Please return to your basket and try again.`);
    }

    const mergedProps = buildGigglzCardProperties(
      currentEntry.item.properties || {},
      card
    );

    await cartChangeByLine(currentEntry.line, {
      quantity: currentEntry.item.quantity,
      properties: mergedProps
    });
  }

  const finalCart = await getCart();
  return verifyPersistedCheckoutCart(state, finalCart);
}

// Keep Liquid-rendered delivery option labels intact.
// Only normalise the selected value.
  function refreshDeliveryMethodSelect() {
    const select = document.getElementById('dw-speed');
    if (!select) return;

    // Leave the option labels exactly as Liquid rendered them.
    // Only normalise the selected value.
    const current = normaliseDeliveryMethod(select.value);
    if (select.value !== current) {
      select.value = current;
    }
  }

  function buildDeliverySummary(d) {
    if (!d) return null;
    const bits = [];

    // sendTo is always set by the time we mark complete=true, but keep safe default:
    bits.push(d.sendTo === 'me' ? 'Me (envelope)' : 'Them');

    const a = d.address || {};
    const addr = [a.line1, a.line2, a.city, a.county, normalisePostcode(a.postcode)]
      .filter(Boolean);
    if (addr.length) bits.push(addr.join(', '));

    if (d.speed) bits.push(`Delivery: ${getDeliveryMethodLabel(d.speed)}`);

    if (d.schedule && d.schedule.type === 'date' && d.schedule.date) {
      bits.push(`Date: ${d.schedule.date}`);
    } else {
      bits.push('ASAP');
    }
    return bits.join(' · ');
  }

  function validateDelivery(delivery) {
  const errors = [];
  const a = (delivery && delivery.address) ? delivery.address : {};

  if (!delivery || !delivery.sendTo) errors.push('Please choose who this is being sent to.');
  if (!a.fullName || a.fullName.trim().length < 2) errors.push('Full name is required.');
  if (!a.line1 || a.line1.trim().length < 3) errors.push('Address line 1 is required.');
  if (!a.city || a.city.trim().length < 2) errors.push('Town / city is required.');

  const pc = normalisePostcode(a.postcode);
  if (!pc) errors.push('Postcode is required.');
  else if (!isProbablyUKPostcode(pc)) errors.push('Please enter a valid UK postcode.');

  if (delivery) {
    delivery.speed = normaliseDeliveryMethod(delivery.speed);
  }

  if (delivery && delivery.schedule && delivery.schedule.type === 'date') {
    const scheduleCheck = validateScheduleDateValue(delivery.schedule.date);
    if (!scheduleCheck.ok) {
      errors.push(scheduleCheck.message);
    }
  }

  return { ok: errors.length === 0, errors };
}

  function showEditorError(msgs) {
    if (!editorErrorEl) return;
    const text = Array.isArray(msgs) ? msgs.join('\n') : String(msgs || '');

    if (!text) {
      editorErrorEl.hidden = true;
      editorErrorEl.textContent = '';
      return;
    }

    editorErrorEl.hidden = false;
    editorErrorEl.textContent = text;

    const panel = editorEl ? editorEl.querySelector('.dw-modal__panel') : null;
    if (panel && typeof panel.scrollTo === 'function') {
      panel.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      editorErrorEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function ensureDeliveryShape(card) {
    if (!card.delivery) {
      card.delivery = {
        sendTo: 'them',
        address: { fullName: '', line1: '', line2: '', city: '', county: '', postcode: '' },
        savedAddressId: null,
        speed: DEFAULT_DELIVERY_METHOD,
        schedule: { type: 'asap' },
        includeEnvelope: false
      };
      return;
    }
    card.delivery.address = card.delivery.address || { fullName: '', line1: '', line2: '', city: '', county: '', postcode: '' };
    card.delivery.savedAddressId = (card.delivery.savedAddressId == null) ? null : card.delivery.savedAddressId;
    card.delivery.speed = normaliseDeliveryMethod(card.delivery.speed);
    card.delivery.schedule = card.delivery.schedule || { type: 'asap' };
    if (card.delivery.sendTo == null) card.delivery.sendTo = 'them';
    if (card.delivery.includeEnvelope == null) card.delivery.includeEnvelope = (card.delivery.sendTo === 'me');
  }

  function normaliseStateDeliveryMethods(state) {
    if (!state || !Array.isArray(state.cards)) return state;

    state.cards.forEach((card) => {
      if (!card) return;
      ensureDeliveryShape(card);
      applyProdigiMetadata(card);

      if (card.complete && card.delivery) {
        card.summary = buildDeliverySummary(card.delivery);
      }
    });

    return state;
  }

  // Send List lines (_gigglz_send_list_id) arrive with full delivery details
  // from the list page. The wizard ignores them: getCart() returns only the
  // other lines, each tagged with its real basket line number in __line so
  // /cart/change.js calls still hit the right line.
  let listLineSummary = { count: 0, name: '', page: '' };

  function isSendListItem(item) {
    const p = (item && item.properties) || {};
    return String(p._gigglz_send_list_id || '').trim() !== '';
  }

  function lineOf(item, index) {
    return (item && item.__line) || index + 1;
  }

  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('Could not load cart');
    const raw = await res.json();
    const items = Array.isArray(raw.items) ? raw.items : [];
    const kept = [];
    const summary = { count: 0, name: '', page: '' };

    items.forEach((item, index) => {
      if (isSendListItem(item)) {
        const p = item.properties || {};
        summary.count += Number(item.quantity) || 0;
        if (!summary.name) summary.name = String(p._gigglz_send_list_name || '').trim();
        if (!summary.page) summary.page = String(p._gigglz_send_list_page || '').trim();
        return;
      }
      kept.push(Object.assign({}, item, { __line: index + 1 }));
    });

    listLineSummary = summary;
    if (!summary.count) return Object.assign({}, raw, { items: kept });

    const keptCount = kept.reduce((total, item) => total + (Number(item.quantity) || 0), 0);
    return Object.assign({}, raw, { items: kept, item_count: keptCount });
  }

  function showListNotice() {
    if (!mainEl) return;
    let el = document.getElementById('dw-list-note');
    if (!listLineSummary.count) {
      if (el) el.remove();
      return;
    }
    if (!el) {
      el = document.createElement('div');
      el.id = 'dw-list-note';
      el.className = 'dw-list-note';
      el.setAttribute('role', 'note');
      el.style.cssText = 'margin:0 0 16px;padding:12px 14px;border-radius:10px;background:rgba(0,0,0,0.04);font-size:1.4rem;line-height:1.5';
      mainEl.insertBefore(el, mainEl.firstChild);
    }
    const n = listLineSummary.count;
    const name = listLineSummary.name || 'card list';
    el.textContent = `Your ${name} (${n} card${n === 1 ? '' : 's'}) is already addressed and will be included at checkout. You only need to set up delivery for the cards below.`;
  }

  async function cartChangeByLine(line, payload) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.assign({ line }, payload))
    });
    if (!res.ok) throw new Error('Could not update cart');
    return res.json();
  }

  async function cartAdd(variantId, quantity, properties) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity, properties })
    });
    if (!res.ok) throw new Error('Could not add to basket');
    return res.json();
  }

  function getMessageFromItem(item) {
    const p = item && item.properties ? item.properties : {};
    const msg = p[PROP.MESSAGE];
    return (typeof msg === 'string' && msg.trim().length > 0) ? msg : '';
  }

  function hasUid(item) {
    const p = item && item.properties ? item.properties : {};
    return !!p[PROP.UID];
  }

  function getUid(item) {
    const p = item && item.properties ? item.properties : {};
    return p[PROP.UID] || '';
  }

  function savedStateMatchesCurrentCart(state, cart) {
    if (
      !state ||
      !Array.isArray(state.cards) ||
      !cart ||
      !Array.isArray(cart.items)
    ) {
      return false;
    }

    const savedCardIds = new Set(
      state.cards
        .map(card => String(card && card.id ? card.id : ''))
        .filter(Boolean)
    );

    return cart.items.some(item => {
      const uid = String(getUid(item) || '');
      return uid && savedCardIds.has(uid);
    });
  }

  function getAssetKeyFromItem(item, propName) {
  const p = item && item.properties ? item.properties : {};
  const v = p[propName];
  return (typeof v === 'string' && v.trim().length > 0) ? v.trim() : '';
  }

  /**
   * Ensure:
   *  - Every cart line has _gigglz_uid
   *  - No cart line has quantity > 1 (split into multiple lines qty 1)
   *
   * IMPORTANT: properties are on the line. If qty>1 and we want per-card messages/addresses,
   * we MUST split the line into multiple line items.
   */
  async function normaliseCartIfNeeded(cart) {
    const initialItems = cart && Array.isArray(cart.items) ? cart.items : [];
    const token = cart && cart.token ? cart.token : '';
    const signature = `${token}:${initialItems.length}:${(cart && cart.item_count) || 0}`;

    const needsSplit = initialItems.some(item => (Number(item.quantity) || 0) > 1 && !isPackItem(item));
    const needsUid = initialItems.some(item => !hasUid(item));

    if (!needsSplit && !needsUid) {
      // Validate that existing identifiers are unique before trusting the basket.
      buildCheckoutCartIndex(cart);
      sessionStorage.setItem(NORMALISE_KEY, signature);
      return cart;
    }

    // 1) Give every current line a UID.
    //
    // IMPORTANT:
    // Shopify line-item keys are not stable. They can change when line-item
    // properties or automatic discount allocations change. Therefore never
    // retain a Shopify line key across cart mutations here.
    //
    // Instead, refetch the cart, find one CURRENT line without a UID,
    // update that current line, then repeat.

    let uidAssignmentCount = 0;

    while (true) {
      const latestCart = await getCart();
      const latestItems = Array.isArray(latestCart.items)
        ? latestCart.items
        : [];

      const targetIndex = latestItems.findIndex(item => !hasUid(item));

      // Every line now has a UID.
      if (targetIndex === -1) {
        cart = latestCart;
        break;
      }

      // Defensive guard against an unexpected loop.
      uidAssignmentCount += 1;

      if (uidAssignmentCount > 100) {
        throw new Error(
          'The basket could not be prepared for delivery. Please return to your basket and try again.'
        );
      }

      const currentItem = latestItems[targetIndex];
      const props = Object.assign({}, currentItem.properties || {});

      props[PROP.UID] = makeUid();

      await cartChangeByLine(lineOf(currentItem, targetIndex), {
        properties: props,
        quantity: currentItem.quantity
      });
    }

    cart = await getCart();

    // At this point every line must have one unique UID. Quantities may still
    // exceed one because they are split in the next stage.
    const seenBeforeSplit = new Set();
    (cart.items || []).forEach((item, index) => {
      const uid = String(getUid(item) || '').trim();
      if (!uid) {
        throw new Error(`Basket line ${index + 1} is missing its Gigglz card ID after normalisation.`);
      }
      if (seenBeforeSplit.has(uid)) {
        throw new Error(`Your basket contains duplicate Gigglz card IDs (${uid}). Please return to your basket and try again.`);
      }
      seenBeforeSplit.add(uid);
    });

    // 2) Split quantity lines into one line per physical card. Resolve the
    // current line by UID immediately before removing it; never reuse a line
    // number from an earlier cart snapshot.
    const splitTargets = (cart.items || [])
      .filter(item => (Number(item.quantity) || 0) > 1 && !isPackItem(item))
      .map(item => String(getUid(item) || '').trim());

    for (const uid of splitTargets) {
      const latestCart = await getCart();
      const matches = (latestCart.items || [])
        .map((item, index) => ({ item, line: lineOf(item, index) }))
        .filter(entry => String(getUid(entry.item) || '').trim() === uid);

      if (matches.length !== 1) {
        throw new Error(`The basket line for Gigglz card ID ${uid} could not be identified uniquely.`);
      }

      const currentEntry = matches[0];
      const qty = Number(currentEntry.item.quantity) || 0;

      if (qty <= 1) {
        continue;
      }

      const variantId = currentEntry.item.variant_id;
      if (!variantId) {
        throw new Error('A card is missing its Shopify variant ID and cannot be prepared for delivery.');
      }

      const baseProps = Object.assign({}, currentEntry.item.properties || {});

      await cartChangeByLine(currentEntry.line, { quantity: 0 });
      await cartAdd(variantId, 1, Object.assign({}, baseProps));

      for (let copyNumber = 2; copyNumber <= qty; copyNumber++) {
        const copyProps = Object.assign({}, baseProps);
        copyProps[PROP.UID] = makeUid();
        await cartAdd(variantId, 1, copyProps);
      }
    }

    const finalCart = await getCart();

    // Final normalisation integrity check: one unique UID and quantity one for
    // every basket line.
    buildCheckoutCartIndex(finalCart);

    const finalToken = finalCart && finalCart.token ? finalCart.token : '';
    const finalSignature = `${finalToken}:${(finalCart.items || []).length}:${(finalCart.item_count || 0)}`;
    sessionStorage.setItem(NORMALISE_KEY, finalSignature);

    return finalCart;
  }

  function initStateFromCart(cart) {
    const cards = (cart.items || []).map((item) => {
      const uid = getUid(item) || makeUid();
      const msg = getMessageFromItem(item);

      const card = {
        id: uid,
        lineKey: item.key,
        title: item.product_title,
        variantTitle: item.variant_title || '',
        image: item.image || null,

        complete: false,
        summary: null,
        delivery: null,
        prodigiSku: null,
        prodigiRateProfile: null,

        frontAssetKey: getAssetKeyFromItem(item, PROP.FRONT_ASSET_KEY),
        backAssetKey: getAssetKeyFromItem(item, PROP.BACK_ASSET_KEY),
        frontSource: getItemProp(item, PROP.FRONT_SOURCE),
        customDesignId: getItemProp(item, PROP.CUSTOM_DESIGN_ID),

        isPack: isPackItem(item),
        packSku: getItemProp(item, PROP.PRODIGI_SKU),
        packRateProfile: getItemProp(item, PROP.RATE_PROFILE) || '7x5_pack',
        packSize: getItemProp(item, PROP.PACK_SIZE),

        hasMessage: msg.length > 0
      };

      return applyProdigiMetadata(card);
    });

    return {
      version: 1,
      mode: null,
      cards
    };
  }

  function syncStateWithCart(state, cart) {
    const existingById = new Map(
      (state.cards || []).map(card => [card.id, card])
    );

    state.cards = (cart.items || []).map((item) => {
      const uid = getUid(item);
      if (!uid) return null;

      const existing = existingById.get(uid);
      const hasMessage = getMessageFromItem(item).length > 0;

      if (existing) {
        ensureDeliveryShape(existing);
        return applyProdigiMetadata({
          ...existing,
          lineKey: item.key,
          title: item.product_title,
          variantTitle: item.variant_title || '',
          image: item.image || null,
          frontAssetKey: getAssetKeyFromItem(item, PROP.FRONT_ASSET_KEY) || existing.frontAssetKey || '',
          backAssetKey: getAssetKeyFromItem(item, PROP.BACK_ASSET_KEY) || existing.backAssetKey || '',
          customDesignId: getItemProp(item, PROP.CUSTOM_DESIGN_ID) || existing.customDesignId || '',
          isPack: isPackItem(item),
          packSku: getItemProp(item, PROP.PRODIGI_SKU) || existing.packSku || '',
          packRateProfile: getItemProp(item, PROP.RATE_PROFILE) || existing.packRateProfile || '7x5_pack',
          packSize: getItemProp(item, PROP.PACK_SIZE) || existing.packSize || '',
          hasMessage
        });
      }

        return applyProdigiMetadata({
          id: uid,
          lineKey: item.key,
          title: item.product_title,
          variantTitle: item.variant_title || '',
          image: item.image || null,
          complete: false,
          summary: null,
          delivery: null,
          prodigiSku: null,
          prodigiRateProfile: null,
          frontAssetKey: getAssetKeyFromItem(item, PROP.FRONT_ASSET_KEY),
          backAssetKey: getAssetKeyFromItem(item, PROP.BACK_ASSET_KEY),
          frontSource: getItemProp(item, PROP.FRONT_SOURCE),
          customDesignId: getItemProp(item, PROP.CUSTOM_DESIGN_ID),
          isPack: isPackItem(item),
          packSku: getItemProp(item, PROP.PRODIGI_SKU),
          packRateProfile: getItemProp(item, PROP.RATE_PROFILE) || '7x5_pack',
          packSize: getItemProp(item, PROP.PACK_SIZE),
          hasMessage
        });

    }).filter(Boolean);

    return normaliseStateDeliveryMethods(state);
  }

  function showModeSelection(state) {
    updateQuestionTextForState(state);
    setModeSelectionVisible(true);

    if (dashboardEl) dashboardEl.hidden = true;

    continueBtn.disabled = true;
    continueBtn.textContent = 'Continue';
    continueBtn.dataset.action = '';
  }

  function updateFooter(state) {
    if (!state) {
      continueBtn.disabled = true;
      continueBtn.textContent = 'Continue';
      continueBtn.dataset.action = '';
      return;
    }

    const cards = Array.isArray(state.cards) ? state.cards : [];
    const allComplete = cards.length > 0 && cards.every(c => c.complete === true);

    if (state.mode === 'multi' || state.mode === 'single' || isSingleCardState(state)) {
      continueBtn.textContent = 'Proceed to payment';
      continueBtn.disabled = !allComplete;
      continueBtn.dataset.action = allComplete ? 'proceed-to-payment' : '';
      return;
    }

    continueBtn.disabled = true;
    continueBtn.textContent = 'Continue';
    continueBtn.dataset.action = '';
  }

  function cardIsSendToMe(card) {
    if (card && card.isPack) return true;
    return !!(
      card &&
      card.delivery &&
      card.delivery.sendTo === 'me'
    );
  }

  function cardCanProceedWithoutMessage(card) {
    // If the customer is sending the card to themselves with an envelope,
    // they may intend to handwrite it, so no inside message is required.
    return cardIsSendToMe(card);
  }

  function cardNeedsMessageGate(card) {
    if (!card) return false;
    if (card.hasMessage) return false;
    if (cardCanProceedWithoutMessage(card)) return false;

    return true;
  }

  function getCardsMissingMessages(state) {
    const cards = state && Array.isArray(state.cards) ? state.cards : [];
    return cards.filter(cardNeedsMessageGate);
  }

  function allCardsComplete(state) {
    const cards = state && Array.isArray(state.cards) ? state.cards : [];
    return cards.length > 0 && cards.every(card => card.complete === true);
  }

  function allCardsMessageReady(state) {
    const cards = state && Array.isArray(state.cards) ? state.cards : [];
    return cards.length > 0 && cards.every(card => !cardNeedsMessageGate(card));
  }

  function shouldProceedDirectlyAfterEditorSave(state) {
    const cards = state && Array.isArray(state.cards) ? state.cards : [];

    if (!allCardsComplete(state)) return false;
    if (!allCardsMessageReady(state)) return false;

    // Scenario 1:
    // One card, delivery details complete, and either:
    // - it has a message, or
    // - it is Send to me / blank envelope.
    if (cards.length === 1) return true;

    // Scenario 2:
    // Multiple cards, all going to one single address, all delivery details complete,
    // and all cards are message-ready.
    if (isSharedSingleAddressMode(state)) return true;

    return false;
  }

  function closeMessageGate() {
    if (!messageGateEl) return;
    messageGateEl.hidden = true;
    messageGateEl.setAttribute('aria-hidden', 'true');
    messageGateEl.dataset.action = '';
    document.documentElement.classList.remove('dw-modal-open');
  }

  function openMessageGate(cards, action) {
    if (!messageGateEl) return;

    const missingCards = Array.isArray(cards) ? cards : [];
    const count = missingCards.length;

    if (messageGateTextEl) {
      messageGateTextEl.textContent =
        count === 1
          ? 'This card does not currently have a message inside. Are you sure you want to continue without adding one?'
          : 'One or more cards do not currently have a message inside. Are you sure you want to continue without adding one?';
    }

    if (messageGateListEl) {
      messageGateListEl.innerHTML = '';
      missingCards.forEach((card, idx) => {
        const li = document.createElement('li');
        li.textContent = `Card ${idx + 1}: ${card.title || 'Card'}`;
        messageGateListEl.appendChild(li);
      });
      messageGateListEl.hidden = missingCards.length === 0;
    }

    messageGateEl.dataset.action = action || '';
    messageGateEl.hidden = false;
    messageGateEl.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('dw-modal-open');

    if (messageGateAddBtn) {
      messageGateAddBtn.focus();
    }
  }

  function validateArtworkKeys(state) {
    const cards = state && Array.isArray(state.cards) ? state.cards : [];
    const missing = cards.filter(card => (!card.frontAssetKey && String(card.frontSource || '').trim().toLowerCase() !== 'custom') || !card.backAssetKey);
    return { ok: missing.length === 0, missing };
  }

  function splitCheckoutName(fullName) {
  const parts = String(fullName || '').trim().split(/\s+/).filter(Boolean);

  if (parts.length === 0) {
    return { firstName: '', lastName: '' };
  }

  // Shopify checkout on Gigglz has first name optional, last name required.
  // For single-word names like "Mum", put it into last name.
  if (parts.length === 1) {
    return { firstName: '', lastName: parts[0] };
  }

  return {
    firstName: parts.slice(0, -1).join(' '),
    lastName: parts[parts.length - 1]
  };
}

function normaliseCheckoutAddressForCompare(address) {
  const a = address || {};

  return [
    a.fullName,
    a.line1,
    a.line2,
    a.city,
    a.county,
    normalisePostcode(a.postcode || '')
  ]
    .map(value => String(value || '').trim().toLowerCase())
    .join('|');
}

function getCheckoutPrefillAddress(state) {
  const cards = state && Array.isArray(state.cards) ? state.cards : [];

  if (!cards.length) return null;

  // Do not prefill for logged-in customers.
  // Shopify / Shop Pay should handle their checkout identity.
  if (customerLoggedIn) return null;

  // Prefill from the "Send to me" address: that is always the buyer's own
  // address. "Send to them" addresses are recipients, so never use those.
  // Mixed baskets prefill too, as long as every "me" card uses one address.
  const sendToMeCards = cards.filter(card =>
    card &&
    card.delivery &&
    card.delivery.sendTo === 'me' &&
    card.delivery.address
  );

  if (!sendToMeCards.length) return null;

  const firstAddress = sendToMeCards[0].delivery.address || {};

  if (
    !String(firstAddress.fullName || '').trim() ||
    !String(firstAddress.line1 || '').trim() ||
    !String(firstAddress.city || '').trim() ||
    !String(firstAddress.postcode || '').trim()
  ) {
    return null;
  }

  const firstKey = normaliseCheckoutAddressForCompare(firstAddress);

  const allSameAddress = sendToMeCards.every(card =>
    normaliseCheckoutAddressForCompare(card.delivery.address || {}) === firstKey
  );

  if (!allSameAddress) return null;

  return firstAddress;
}

function buildCheckoutPrefillUrl(state) {
  const address = getCheckoutPrefillAddress(state);

  if (!address) {
    return '/checkout';
  }

  const name = splitCheckoutName(address.fullName);
  const params = new URLSearchParams();

  if (name.firstName) {
    params.set('checkout[shipping_address][first_name]', name.firstName);
  }

  params.set('checkout[shipping_address][last_name]', name.lastName);
  params.set('checkout[shipping_address][address1]', address.line1 || '');

  if (address.line2) {
    params.set('checkout[shipping_address][address2]', address.line2);
  }

  params.set('checkout[shipping_address][city]', address.city || '');

  if (address.county) {
    params.set('checkout[shipping_address][province]', address.county);
  }

  params.set('checkout[shipping_address][country]', 'United Kingdom');
  params.set('checkout[shipping_address][zip]', normalisePostcode(address.postcode || ''));

  return `/checkout?${params.toString()}`;
}

  async function continueAfterMessageGate(action) {
  if (action !== 'proceed-to-payment') return;

  try {
    let cart = await getCart();
    cart = await normaliseCartIfNeeded(cart);

    currentState = loadState() || currentState;
    if (!currentState || !currentState.version) {
      currentState = initStateFromCart(cart);
    } else {
      currentState = syncStateWithCart(currentState, cart);
    }

    currentState = normaliseStateDeliveryMethods(currentState);
    currentState = reconcileModeWithCardCount(currentState);
    saveState(currentState);

    // Blocking preflight: every cart line and wizard card must have one unique
    // matching UID, confirmed delivery details and valid artwork/production data.
    assertCheckoutStateMatchesCart(currentState, cart);

    // This function refetches the cart before every write, resolves the current
    // line by UID, and verifies the fully persisted cart before returning.
    await persistWizardToCart(currentState);

    const checkoutUrl = buildCheckoutPrefillUrl(currentState);
    window.location.href = checkoutUrl;
  } catch (err) {
    console.error(err);
    alert(
      err && err.message
        ? err.message
        : 'Something went wrong preparing your delivery details for checkout.'
    );
  }
}

  function handleProceed(action) {
    currentState = loadState() || currentState;
    if (!currentState) return;

    const missing = getCardsMissingMessages(currentState);

    if (missing.length > 0) {
      openMessageGate(missing, action);
      return;
    }

    continueAfterMessageGate(action);
  }

  function goToPersonalise(card) {
    if (!card) return;

    const returnUrl = '/pages/delivery';

    try {
      localStorage.setItem(LS.SOURCE, 'delivery');
      localStorage.setItem(LS.RETURN_TO, returnUrl);
      localStorage.setItem(LS.SCROLL_TO_DASHBOARD, 'true');

      if (card.lineKey) {
        localStorage.setItem(LS.LINE_KEY, card.lineKey);
      }
    } catch (e) {}

    const packParam = (card && card.isPack) ? '&item_type=card_pack' : '';

    const url =
      `/pages/personalise?line=${encodeURIComponent(card.lineKey || '')}` +
      `&uid=${encodeURIComponent(card.id || '')}` +
      `&return=${encodeURIComponent(returnUrl)}` +
      `&mode=update` +
      packParam;

    window.location.href = url;
  }

  /* =========================================================
     Editor modal (Step 5)
     ========================================================= */

  function setVal(id, value) {
    const el = document.getElementById(id);
    if (!el) return;
    el.value = value == null ? '' : value;
  }

  function getVal(id) {
    const el = document.getElementById(id);
    return el ? String(el.value || '') : '';
  }

  function setLookupMessage(message, type) {
    if (!addressLookupMessageEl) return;

    addressLookupMessageEl.className = 'dw-note';

    const text = String(message || '').trim();
    if (!text) {
      addressLookupMessageEl.hidden = true;
      addressLookupMessageEl.textContent = '';
      return;
    }

    if (type === 'error') addressLookupMessageEl.classList.add('dw-note--error');
    if (type === 'info') addressLookupMessageEl.classList.add('dw-note--info');
    if (type === 'success') addressLookupMessageEl.classList.add('dw-note--success');

    addressLookupMessageEl.hidden = false;
    addressLookupMessageEl.textContent = text;
  }

  function setSavedAddressMessage(message, type) {
    if (!savedMessageEl) return;

    savedMessageEl.className = 'dw-note';

    const text = String(message || '').trim();
    if (!text) {
      savedMessageEl.hidden = true;
      savedMessageEl.textContent = '';
      return;
    }

    if (type === 'error') savedMessageEl.classList.add('dw-note--error');
    if (type === 'info') savedMessageEl.classList.add('dw-note--info');
    if (type === 'success') savedMessageEl.classList.add('dw-note--success');

    savedMessageEl.hidden = false;
    savedMessageEl.textContent = text;
  }

  function setManualAddressVisible(show) {
    if (addressFieldsWrapEl) addressFieldsWrapEl.hidden = !show;
    if (addressManualToggleEl) addressManualToggleEl.hidden = !!show;
  }

  function addressHasValues(address) {
    if (!address) return false;
    return [address.line1, address.line2, address.city, address.county, address.postcode].some(v => String(v || '').trim() !== '');
  }

  function buildAddressSearchText(address) {
    const a = address || {};
    return [a.line1, a.line2, a.city, normalisePostcode(a.postcode)].filter(Boolean).join(', ');
  }

  function setLookupValue(text) {
    const value = String(text || '');
    addressLookupState.selectedDisplay = value;

    if (addressLookupState.widget && 'value' in addressLookupState.widget) {
      addressLookupState.widget.value = value;
    }
  }

  function clearLookupValue() {
    setLookupValue('');
  }

  function focusAddressLookup() {
    if (addressLookupState.widget && typeof addressLookupState.widget.focus === 'function') {
      try {
        addressLookupState.widget.focus();
        return true;
      } catch (e) {}
    }
    return false;
  }

  function getAddressComponentLookup(components) {
    const lookup = {};

    (components || []).forEach(component => {
      (component.types || []).forEach(type => {
        if (!lookup[type]) lookup[type] = component;
      });
    });

    return lookup;
  }

  function mapPlaceToAddress(place) {
    const lookup = getAddressComponentLookup(place && place.addressComponents ? place.addressComponents : []);
    const longText = (type) => (lookup[type] ? (lookup[type].longText || lookup[type].long_name || '') : '');
    const shortText = (type) => (lookup[type] ? (lookup[type].shortText || lookup[type].short_name || lookup[type].longText || lookup[type].long_name || '') : '');

    const subpremise = longText('subpremise');
    const premise = longText('premise');
    const streetNumber = longText('street_number');
    const route = longText('route');
    const postalTown = longText('postal_town');
    const locality = longText('locality');
    const sublocality = longText('sublocality_level_1');
    const admin2 = longText('administrative_area_level_2');
    const admin1 = longText('administrative_area_level_1');
    const postalCode = longText('postal_code');
    const postalCodeSuffix = longText('postal_code_suffix');

    let line1 = '';
    let line2 = '';

    if (subpremise && premise) {
      line1 = `${subpremise}, ${premise}`;
      line2 = [streetNumber, route].filter(Boolean).join(' ');
    } else if (premise && (streetNumber || route)) {
      line1 = premise;
      line2 = [streetNumber, route].filter(Boolean).join(' ');
    } else if (premise) {
      line1 = premise;
    } else {
      line1 = [streetNumber, route].filter(Boolean).join(' ');
    }

    if (!line1 && place && place.formattedAddress) {
      line1 = String(place.formattedAddress).split(',')[0].trim();
    }

    let county = admin2 || admin1 || '';
    if (['England', 'Scotland', 'Wales', 'Northern Ireland'].includes(county)) {
      county = admin2 || '';
    }

    return {
      fullName: getVal('dw-fullname'),
      line1: line1 || '',
      line2: line2 || '',
      city: postalTown || locality || sublocality || admin2 || '',
      county: county || '',
      postcode: normalisePostcode([postalCode, postalCodeSuffix].filter(Boolean).join(' '))
    };
  }

  function fillManualAddressFields(address, opts) {
    const a = address || {};
    const options = opts || {};

    if (!options.keepExistingFullName) {
      setVal('dw-fullname', a.fullName || '');
    }

    setVal('dw-line1', a.line1 || '');
    setVal('dw-line2', a.line2 || '');
    setVal('dw-city', a.city || '');
    setVal('dw-county', a.county || '');
    setVal('dw-postcode', a.postcode || '');
  }

  function formatSavedAddressLabel(address) {
    if (!address) return '';
    return [address.fullName, address.postcode].filter(Boolean).join(' — ');
  }

  function sortSavedAddresses(addresses) {
    return [...(addresses || [])].sort((a, b) => {
      if (!!a.isDefault !== !!b.isDefault) return a.isDefault ? -1 : 1;
      return String(b.lastUsedAt || '').localeCompare(String(a.lastUsedAt || ''));
    });
  }

  async function loadSavedAddresses(force = false) {
    if (!customerLoggedIn) {
      savedAddressesCache = [];
      savedAddressesLoaded = true;
      return savedAddressesCache;
    }

    if (savedAddressesLoaded && !force) return savedAddressesCache;
    if (savedAddressesPromise && !force) return savedAddressesPromise;

    savedAddressesPromise = (async () => {
      try {
        const res = await fetch('/apps/gigglz/saved-addresses', {
          method: 'GET',
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });

        if (!res.ok) throw new Error(`Saved addresses request failed: ${res.status}`);

        const data = await res.json();
        savedAddressesCache = sortSavedAddresses(Array.isArray(data.addresses) ? data.addresses : []);
        savedAddressesLoaded = true;
        return savedAddressesCache;
      } catch (err) {
        console.error('Could not load saved addresses', err);
        savedAddressesCache = [];
        savedAddressesLoaded = false;
        return savedAddressesCache;
      } finally {
        savedAddressesPromise = null;
      }
    })();

    return savedAddressesPromise;
  }

  function preloadSavedAddresses() {
    if (!savedWrap || !customerLoggedIn) return;
    loadSavedAddresses().catch(() => {});
  }

  async function autoSaveAddress(address) {
    try {
      const payload = {
        address: {
          fullName: String(address && address.fullName || '').trim(),
          line1: String(address && address.line1 || '').trim(),
          line2: String(address && address.line2 || '').trim(),
          city: String(address && address.city || '').trim(),
          county: String(address && address.county || '').trim(),
          postcode: normalisePostcode(address && address.postcode || ''),
          countryCode: 'GB'
        }
      };

      const res = await fetch('/apps/gigglz/saved-addresses', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!res.ok) throw new Error(`Saved address POST failed: ${res.status}`);

      const data = await res.json();

      if (data && data.ok && data.loggedIn && data.saved) {
        savedAddressesCache = sortSavedAddresses(Array.isArray(data.addresses) ? data.addresses : []);
        savedAddressesLoaded = true;
        return data.addressId || null;
      }

      return null;
    } catch (err) {
      console.error('Could not auto-save address', err);
      return null;
    }
  }

  function getSavedAddressById(id) {
    return savedAddressesCache.find(a => String(a.id) === String(id)) || null;
  }

  function setCurrentSavedAddressId(id) {
    currentSavedAddressId = id || null;

    if (savedSelect) {
      savedSelect.value = currentSavedAddressId || '';
    }

  }

  function clearCurrentSavedAddressId() {
    setCurrentSavedAddressId(null);
  }

  function applySavedAddress(address) {
    if (!address) return;

    fillManualAddressFields(address);
    setManualAddressVisible(true);
    setLookupValue(buildAddressSearchText(address));
    setSavedAddressMessage('Saved address applied. Please check the details before saving.', 'success');
    setCurrentSavedAddressId(address.id);
    showEditorError('');
  }

  function bindManualAddressDirtyTracking() {
    ['dw-fullname', 'dw-line1', 'dw-line2', 'dw-city', 'dw-county', 'dw-postcode'].forEach(id => {
      const el = document.getElementById(id);
      if (!el || el.dataset.savedAddressTracked === 'true') return;

      el.dataset.savedAddressTracked = 'true';
      el.addEventListener('input', () => {
        if (currentSavedAddressId) {
          clearCurrentSavedAddressId();
        }
        setSavedAddressMessage('', '');
      });
    });
  }

  function markLookupUnavailable() {
    if (addressSearchHostEl) addressSearchHostEl.hidden = true;
    setManualAddressVisible(true);
    setLookupMessage('Address lookup unavailable, please enter address manually.', 'error');
  }

  async function handleLookupSelection(placePrediction) {
    try {
      if (!placePrediction || typeof placePrediction.toPlace !== 'function') {
        setLookupMessage('Please choose an address from the list, or enter it manually.', 'error');
        setManualAddressVisible(true);
        return;
      }

      const place = placePrediction.toPlace();
      await place.fetchFields({ fields: ['addressComponents', 'formattedAddress', 'location'] });

      if (!place.addressComponents || !place.addressComponents.length) {
        setLookupMessage('Please choose an address from the list, or enter it manually.', 'error');
        setManualAddressVisible(true);
        return;
      }

    const mapped = mapPlaceToAddress(place);

    fillManualAddressFields(mapped, { keepExistingFullName: true });
    clearCurrentSavedAddressId();
    setSavedAddressMessage('', '');
    setManualAddressVisible(true);
    setLookupValue(place.formattedAddress || buildAddressSearchText(mapped));
    setLookupMessage('Address found. Please check the details before saving.', 'success');
    showEditorError('');

    // Match the mobile checkout pattern used by sites such as Thortful:
    // once an address is selected, dismiss the keyboard so the customer
    // can review the completed fields and scroll naturally to Save.
    if (
      addressLookupState.widget &&
      typeof addressLookupState.widget.blur === 'function'
    ) {
      try {
        addressLookupState.widget.blur();
      } catch (e) {}
    }

    if (
      document.activeElement &&
      typeof document.activeElement.blur === 'function'
    ) {
      document.activeElement.blur();
    }

    } catch (err) {
      markLookupUnavailable();
    }
  }

  async function initAddressLookup() {
    if (!addressSearchHostEl) return false;

    if (addressLookupState.initialised && addressLookupState.widget) {
      addressSearchHostEl.hidden = false;
      return true;
    }

    try {
      const placesLib = await google.maps.importLibrary('places');
      const PlaceAutocompleteElement = placesLib && placesLib.PlaceAutocompleteElement
        ? placesLib.PlaceAutocompleteElement
        : (google.maps.places && google.maps.places.PlaceAutocompleteElement);

      if (!PlaceAutocompleteElement) {
        markLookupUnavailable();
        return false;
      }

      addressSearchHostEl.innerHTML = '';
      addressSearchHostEl.hidden = false;

      const widget = new PlaceAutocompleteElement();

      // Use the documented property flow for the new widget.
      widget.includedRegionCodes = ['gb'];
      widget.requestedLanguage = 'en-GB';
      widget.requestedRegion = 'gb';
      widget.placeholder = 'Start typing your address...';
      widget.name = 'dwLookupQuery';

      widget.addEventListener('gmp-select', async (event) => {
        const placePrediction = event && event.placePrediction ? event.placePrediction : null;
        await handleLookupSelection(placePrediction);
      });

      widget.addEventListener('gmp-error', () => {
        markLookupUnavailable();
      });

      addressSearchHostEl.appendChild(widget);

      addressLookupState.widget = widget;
      addressLookupState.initialised = true;
      addressLookupState.selectedDisplay = '';

      setLookupMessage('', '');
      return true;
    } catch (err) {
      markLookupUnavailable();
      return false;
    }
  }

  document.addEventListener('focusin', function () {
    const activeElement = document.activeElement;

    if (
      activeElement &&
      typeof activeElement.matches === 'function' &&
      activeElement.matches('gmp-place-autocomplete')
    ) {
      window.scrollTo(0, 0);
    }
  });

  function setAddressUiFromDelivery(delivery) {
    const address = (delivery && delivery.address) ? delivery.address : {};
    const hasAddress = addressHasValues(address);

    if (hasAddress) {
      setManualAddressVisible(true);
      setLookupValue(buildAddressSearchText(address));
    } else {
      setManualAddressVisible(false);
      clearLookupValue();
    }

    setLookupMessage('', '');
  }

  // NEW: update the Send-to toggle UI from a value
  function setSendToUI(value, allowSendToMe, forceSendToMe) {
    const v = (value === 'me' || value === 'them') ? value : 'them';

    // If "me" is not allowed, force "them". For packs, force "me".
    let forced = (allowSendToMe === false) ? 'them' : v;
    if (forceSendToMe) forced = 'me';

    if (sendToInputEl) sendToInputEl.value = forced;
    if (sendToggleEl) sendToggleEl.dataset.forcePack = forceSendToMe ? 'true' : 'false';
    updateSpeedOptionLabels(getPriceHintKey(forced, !!forceSendToMe));

    if (sendToggleEl) {
      const btnMe = sendToggleEl.querySelector('.dw-send-option[data-value="me"]');
      const btnThem = sendToggleEl.querySelector('.dw-send-option[data-value="them"]');
      if (btnMe) btnMe.hidden = (allowSendToMe === false) && !forceSendToMe;
      if (btnThem) btnThem.hidden = !!forceSendToMe;

      sendToggleEl.querySelectorAll('.dw-send-option').forEach(btn => {
        const isSel = btn.dataset.value === forced && forced !== '';
        btn.classList.toggle('is-selected', isSel);
        btn.setAttribute('aria-pressed', isSel ? 'true' : 'false');
      });
    }
  }

  function setScheduleTypeUI(value) {
  const v = (value === 'date') ? 'date' : 'asap';

  if (scheduleTypeInputEl) scheduleTypeInputEl.value = v;

  if (scheduleToggleEl) {
    scheduleToggleEl.querySelectorAll('.dw-schedule-option').forEach(btn => {
      const isSel = btn.dataset.value === v;
      btn.classList.toggle('is-selected', isSel);
      btn.setAttribute('aria-pressed', isSel ? 'true' : 'false');
    });
  }

  if (scheduleDateRow) scheduleDateRow.hidden = (v !== 'date');

  if (v !== 'date') {
    if (scheduleDateEl) scheduleDateEl.value = '';
    setScheduleHelpText(`Choose a delivery date at least ${deliveryLeadWorkingDaysDefault} working days away.`);
  }
}

  function setFormFromDelivery(delivery, opts) {
  const d = delivery || {};
  const options = opts || {};
  const allowSendToMe = options.allowSendToMe !== false;
  const forceSendToMe = options.forceSendToMe === true;

  setSendToUI(d.sendTo, allowSendToMe, forceSendToMe);

  const st = (d.schedule && d.schedule.type) ? d.schedule.type : 'asap';
  setScheduleTypeUI(st);

  if (scheduleDateEl) {
    scheduleDateEl.value = (st === 'date' && d.schedule && d.schedule.date) ? d.schedule.date : '';
  }

  const a = d.address || {};
  setVal('dw-fullname', a.fullName);
  setVal('dw-line1', a.line1);
  setVal('dw-line2', a.line2);
  setVal('dw-city', a.city);
  setVal('dw-county', a.county);
  setVal('dw-postcode', a.postcode);

  refreshDeliveryMethodSelect();
  setVal('dw-speed', normaliseDeliveryMethod(d.speed));

  setAddressUiFromDelivery(d);

  if (st === 'date') {
    refreshScheduleDateOptionsForEditor(true).catch(() => {});
  } else {
    setScheduleHelpText(`Choose a delivery date at least ${deliveryLeadWorkingDaysDefault} working days away.`);
  }
}

  function getDeliveryFromForm(opts) {
    const options = opts || {};
    const allowSendToMe = options.allowSendToMe !== false;
    const forceSendToMe = options.forceSendToMe === true;

    // Read from hidden field instead of radios
    let sendTo = sendToInputEl ? String(sendToInputEl.value || 'them') : 'them';

    // If "me" isn't allowed, force them. For packs, force me.
    if (!allowSendToMe) sendTo = 'them';
    if (forceSendToMe) sendTo = 'me';

    const scheduleType = scheduleTypeInputEl ? String(scheduleTypeInputEl.value || 'asap') : 'asap';
    const schedule = scheduleType === 'date'
      ? { type: 'date', date: (scheduleDateEl && scheduleDateEl.value) ? scheduleDateEl.value : '' }
      : { type: 'asap' };

    const delivery = {
      sendTo: sendTo || '',
      address: {
        fullName: getVal('dw-fullname'),
        line1: getVal('dw-line1'),
        line2: getVal('dw-line2'),
        city: getVal('dw-city'),
        county: getVal('dw-county'),
        postcode: normalisePostcode(getVal('dw-postcode'))
      },
      savedAddressId: currentSavedAddressId,
      speed: normaliseDeliveryMethod(getVal('dw-speed')),
      schedule,
      includeEnvelope: (sendTo === 'me')
    };

    return delivery;
  }

  async function initSavedAddressesHook(selectedId) {
    if (!savedWrap) return;

    if (!customerLoggedIn) {
      savedWrap.hidden = true;
      if (savedSelect) {
        savedSelect.disabled = false;
        savedSelect.innerHTML = '<option value="">Select an address...</option>';
      }
      return;
    }

    if (!savedAddressesLoaded && savedSelect) {
      savedWrap.hidden = false;
      savedSelect.disabled = true;
      savedSelect.innerHTML = '<option value="">Loading saved addresses...</option>';
    }

    const addresses = await loadSavedAddresses();

    if (!addresses.length) {
      savedWrap.hidden = true;
      if (savedSelect) {
        savedSelect.disabled = false;
        savedSelect.innerHTML = '<option value="">Select an address...</option>';
      }
      return;
    }

    savedWrap.hidden = false;

    if (savedSelect) {
      savedSelect.disabled = false;
      savedSelect.innerHTML = '<option value="">Select an address...</option>';

      addresses.forEach(a => {
        const opt = document.createElement('option');
        opt.value = a.id;
        opt.textContent = formatSavedAddressLabel(a);
        savedSelect.appendChild(opt);
      });
    }

    setCurrentSavedAddressId(selectedId || null);
  }

  function initPostcodeLookupHook() {
    if (postcodeLookupRowEl) postcodeLookupRowEl.hidden = true;
    if (dividerEl) dividerEl.hidden = true;
    if (pcResultsWrap) pcResultsWrap.hidden = true;
    if (pcSelectEl) pcSelectEl.innerHTML = '<option value="">Select...</option>';
  }

  function stubFindAddressesByPostcode() {
    const pc = normalisePostcode(pcInputEl ? pcInputEl.value : '');
    if (!pc) {
      showEditorError('Enter a postcode to find addresses.');
      return;
    }
    if (!isProbablyUKPostcode(pc)) {
      showEditorError('That postcode doesn\'t look valid. Please check it.');
      return;
    }

    showEditorError('');
    if (pcResultsWrap) pcResultsWrap.hidden = false;
    if (pcSelectEl) pcSelectEl.innerHTML = '<option value="">(Hook) No results yet...</option>';
  }

  function useSelectedSavedAddress() {
    if (!savedSelect || !savedSelect.value) return;

    const address = getSavedAddressById(savedSelect.value);
    if (!address) {
      showEditorError('That saved address could not be found.');
      return;
    }

    applySavedAddress(address);
  }

  function applyDefaultSendToIfNeeded(card, state) {
    ensureDeliveryShape(card);

    const hasExistingAddress = addressHasValues(card.delivery.address);
    const hasSummary = !!card.summary;
    const isUntouched = !card.complete && !hasExistingAddress && !hasSummary;

    if (!isUntouched) return;

    const defaultSendTo = card.isPack ? 'me' : getDefaultSendToForState(state);
    card.delivery.sendTo = defaultSendTo;
    card.delivery.includeEnvelope = (defaultSendTo === 'me');
    applyProdigiMetadata(card);
  }

  function resetEditorScrollToTop() {
    if (!editorEl) return;

    const panel = editorEl.querySelector('.dw-modal__panel');

    if (!panel) return;

    panel.scrollTop = 0;

    requestAnimationFrame(() => {
      panel.scrollTop = 0;
    });
  }

  function openEditor(card, opts) {
    if (!editorEl || !editorForm || !card) return;

    const options = opts || {};
    const isPack = !!(card && card.isPack);
    const allowSendToMe = isPack ? true : (options.allowSendToMe !== false);
    const forceSendToMe = isPack;
    const applyToAll = options.applyToAll === true;

    ensureDeliveryShape(card);
    applyDefaultSendToIfNeeded(card, currentState);

    if (editorCardIdEl) editorCardIdEl.value = card.id;
    if (editorEl) editorEl.dataset.applyToAll = applyToAll ? 'true' : 'false';

    // Packs are self-send only: force send-to-me. Otherwise, if send-to-me
    // isn't allowed, force state to them.
    if (forceSendToMe) {
      card.delivery.sendTo = 'me';
      card.delivery.includeEnvelope = true;
      applyProdigiMetadata(card);
    } else if (!allowSendToMe && card.delivery.sendTo === 'me') {
      card.delivery.sendTo = 'them';
      card.delivery.includeEnvelope = false;
      applyProdigiMetadata(card);
    }

    // Populate form
    setFormFromDelivery(card.delivery, { allowSendToMe, forceSendToMe });
    
    currentSavedAddressId = card.delivery && card.delivery.savedAddressId
    ? card.delivery.savedAddressId
    : null;

    initSavedAddressesHook(currentSavedAddressId);

    initPostcodeLookupHook();
    initAddressLookup();
    showEditorError('');
    setSavedAddressMessage('', '');
    refreshScheduleDateOptionsForEditor(true).catch(() => {});
    editorEl.hidden = false;
    editorEl.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('dw-modal-open');

    resetEditorScrollToTop();
  }

  function closeEditor() {
    if (!editorEl) return;

    editorEl.hidden = true;
    editorEl.setAttribute('aria-hidden', 'true');
    editorEl.dataset.applyToAll = 'false';

    document.documentElement.classList.remove('dw-modal-open');

    showEditorError('');
    setSavedAddressMessage('', '');
    setLookupMessage('', '');

    document.documentElement.style.setProperty(
      '--dw-keyboard-space',
      '0px'
    );
  }
  
  function bindEditorEventsOnce() {
    if (!editorEl || !editorForm || bindEditorEventsOnce.bound) return;
    bindEditorEventsOnce.bound = true;

    editorEl.querySelectorAll('[data-dw-editor-close],[data-dw-editor-back]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        closeEditor();
      });
    });

    // Backdrop click closes
    const backdrop = editorEl.querySelector('.dw-modal__backdrop');
    if (backdrop) {
      backdrop.addEventListener('click', (e) => {
        e.preventDefault();
        closeEditor();
      });
    }

    // Send-to toggle behaviour
    if (addressManualToggleEl) {
      addressManualToggleEl.addEventListener('click', (e) => {
        e.preventDefault();
        setManualAddressVisible(true);
        setLookupMessage('', '');
        const firstManual = document.getElementById('dw-line1') || document.getElementById('dw-fullname');
        if (firstManual) firstManual.focus();
      });
    }

    bindManualAddressDirtyTracking();

    if (sendToggleEl && sendToInputEl) {
      sendToggleEl.querySelectorAll('.dw-send-option').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const v = btn.dataset.value === 'me' ? 'me' : 'them';
          sendToInputEl.value = v;
          updateSpeedOptionLabels(getPriceHintKey(v, sendToggleEl.dataset.forcePack === 'true'));

          sendToggleEl.querySelectorAll('.dw-send-option').forEach(b => {
            const isSel = b.dataset.value === v;
            b.classList.toggle('is-selected', isSel);
            b.setAttribute('aria-pressed', isSel ? 'true' : 'false');
          });

          // If user chooses, clear just the "choose sendTo" error (or all errors if you prefer)
          showEditorError('');
        });
      });
    }

    if (scheduleToggleEl) {
      scheduleToggleEl.querySelectorAll('.dw-schedule-option').forEach(btn => {
        btn.addEventListener('click', async (e) => {
          e.preventDefault();
          setScheduleTypeUI(btn.dataset.value);
          showEditorError('');

          if (btn.dataset.value === 'date') {
            await refreshScheduleDateOptionsForEditor(true);
          }
        });
      });
    }

    const speedSelectEl = document.getElementById('dw-speed');
    if (speedSelectEl) {
      refreshDeliveryMethodSelect();
      speedSelectEl.addEventListener('change', async () => {
        speedSelectEl.value = normaliseDeliveryMethod(speedSelectEl.value);
        showEditorError('');

        if (scheduleTypeInputEl && scheduleTypeInputEl.value === 'date') {
          await refreshScheduleDateOptionsForEditor(true);
        }
      });
    }

    if (scheduleDateEl) {
      scheduleDateEl.addEventListener('change', () => {
        if (scheduleTypeInputEl && scheduleTypeInputEl.value !== 'date') return;

        const check = validateScheduleDateValue(scheduleDateEl.value);
        if (!check.ok) {
          scheduleDateEl.value = '';
          showEditorError(check.message);
          return;
        }

        showEditorError('');
      });
    }

    // Submit/save
    editorForm.addEventListener('submit', async (e) => {
      e.preventDefault();

      currentState = loadState() || currentState;
      if (!currentState || !currentState.cards) return;

      const cardId = editorCardIdEl ? editorCardIdEl.value : '';
      const card = currentState.cards.find(x => String(x.id) === String(cardId));
      if (!card) return;

      // allowSendToMe depends on mode/state; packs force send-to-me.
      const isPack = !!(card && card.isPack);
      const allowSendToMe = isPack ? true : allowSendToMeForState(currentState);
      const forceSendToMe = isPack;
      const delivery = getDeliveryFromForm({ allowSendToMe, forceSendToMe });

      if (!addressHasValues(delivery.address)) {
        showEditorError('Please select an address from the lookup or enter it manually.');
        return;
      }

      const v = validateDelivery(delivery);
      if (!v.ok) {
        showEditorError(v.errors);
        return;
      }

      const savedId = await autoSaveAddress(delivery.address);
      if (savedId) {
        delivery.savedAddressId = savedId;
        currentSavedAddressId = savedId;
      }

      const applyToAll = editorEl && editorEl.dataset.applyToAll === 'true';
      const sharedToBuyer = !!(delivery && delivery.sendTo === 'me');

      if (applyToAll && isSharedSingleAddressMode(currentState)) {
        // Single-address mode: apply this delivery to every card. Packs can only
        // go to the buyer, so keep their sendTo as 'me'. If the shared address is
        // a recipient (send-to-them), leave packs for the buyer's own address and
        // only fill the non-pack cards.
        currentState.cards.forEach(function (c) {
          if (c.isPack && !sharedToBuyer) return;
          ensureDeliveryShape(c);
          const cloned = JSON.parse(JSON.stringify(delivery));
          if (c.isPack) cloned.sendTo = 'me';
          c.delivery = cloned;
          c.complete = true;
          c.summary = buildDeliverySummary(cloned);
          applyProdigiMetadata(c);
        });
      } else {
        card.delivery = delivery;
        card.complete = true;
        card.summary = buildDeliverySummary(delivery);
        applyProdigiMetadata(card);
      }

      // Packs can only ever be sent to the buyer. When a send-to-me address
      // is set (from a pack's own editor, or any send-to-me card), apply it to
      // every other pack automatically, so the buyer enters their address once
      // rather than for each pack.
      if (card.isPack || (delivery && delivery.sendTo === 'me')) {
        currentState.cards.forEach(function (c) {
          if (c.id === card.id) return;
          if (!c.isPack) return;
          if (c.complete) return;
          ensureDeliveryShape(c);
          var clonedPack = JSON.parse(JSON.stringify(delivery));
          clonedPack.sendTo = 'me';
          c.delivery = clonedPack;
          c.complete = true;
          c.summary = buildDeliverySummary(clonedPack);
          applyProdigiMetadata(c);
        });
      }

    saveState(currentState);
      currentState = loadState() || currentState;
      currentState = normaliseStateDeliveryMethods(currentState);
      saveState(currentState);
      currentState = loadState() || currentState;

      if (shouldProceedDirectlyAfterEditorSave(currentState)) {
        closeEditor();
        await continueAfterMessageGate('proceed-to-payment');
        return;
      }

      renderCards(currentState);
      updateFooter(currentState);
      closeEditor();

      if (
        currentState &&
        currentState.mode === 'multi' &&
        !isSingleCardState(currentState)
      ) {
        scrollToDashboardHeading();
      }
    });

    // ESC closes whichever modal is open
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;

      if (messageGateEl && !messageGateEl.hidden) {
        closeMessageGate();
        return;
      }

      if (editorEl && !editorEl.hidden) {
        closeEditor();
      }
    });

    // Hooks
    if (pcFindBtn) {
      pcFindBtn.addEventListener('click', (e) => {
        e.preventDefault();
        stubFindAddressesByPostcode();
      });
    }
    if (savedSelect) {
      savedSelect.addEventListener('change', () => {
        if (!savedSelect.value) {
          clearCurrentSavedAddressId();
          return;
        }

        useSelectedSavedAddress();
      });
    }
  }

  function bindMessageGateEventsOnce() {
    if (!messageGateEl || bindMessageGateEventsOnce.bound) return;
    bindMessageGateEventsOnce.bound = true;

    messageGateEl.querySelectorAll('[data-dw-message-gate-close]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        closeMessageGate();
      });
    });

    const backdrop = messageGateEl.querySelector('.dw-modal__backdrop');
    if (backdrop) {
      backdrop.addEventListener('click', (e) => {
        e.preventDefault();
        closeMessageGate();
      });
    }

    if (messageGateAddBtn) {
      messageGateAddBtn.addEventListener('click', (e) => {
        e.preventDefault();

        currentState = loadState() || currentState;
        const missing = getCardsMissingMessages(currentState);
        const firstMissing = missing.length ? missing[0] : null;

        closeMessageGate();

        if (firstMissing) {
          goToPersonalise(firstMissing);
        }
      });
    }

    if (messageGateContinueBtn) {
      messageGateContinueBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const action = messageGateEl ? messageGateEl.dataset.action : '';
        closeMessageGate();
        continueAfterMessageGate(action);
      });
    }
  }

  function cyocPollPreview(img, url) {
    if (!img || !url) return;
    var tries = 0;
    (function attempt() {
      var probe = new Image();
      probe.onload = function () { img.src = url; };
      probe.onerror = function () {
        tries += 1;
        if (tries < 8) setTimeout(attempt, tries < 3 ? 900 : 1800);
      };
      probe.src = url + (url.indexOf('?') >= 0 ? '&' : '?') + '_r=' + Date.now();
    })();
  }

  function renderCards(state) {
    if (!cardsEl) return;

    cardsEl.innerHTML = '';

    (state.cards || []).forEach((c, idx) => {
      const badgeClass = c.complete ? 'dw-badge--done' : 'dw-badge--todo';
      const badgeText = c.complete ? 'Complete' : 'Not set';
      const ctaText = c.complete ? 'View / edit delivery details' : 'Add delivery details';

      const msgBtnText = c.hasMessage ? 'Edit message' : 'Add a message';

      // Custom (CYOC) cards: show the design preview (served via app proxy) and
      // drop the message button, since the inside message is baked into the
      // design and edited in the card designer, not the personalise page.
      const isCustom = c.frontSource === 'custom' || !!c.customDesignId;
      const cyocPreviewUrl = c.customDesignId
        ? ('/apps/gigglz/custom-uploads/preview?id=' + encodeURIComponent(c.customDesignId))
        : '';
      const thumbInner = (isCustom && cyocPreviewUrl)
        ? `<img alt="" data-cyoc-preview="${cyocPreviewUrl}">`
        : (c.image ? `<img src="${c.image}" alt="">` : ``);
      const msgBtnHtml = isCustom
        ? ``
        : `<button class="dw-card__msg" type="button" data-cardid="${c.id}">
                ${msgBtnText}
              </button>`;

      const card = document.createElement('div');
      card.className = 'dw-card';
      card.innerHTML = `
        <div class="dw-card__top">
          <div class="dw-card__name">Card ${idx + 1}</div>
          <div class="dw-badge ${badgeClass}">${badgeText}</div>
        </div>

        <div class="dw-card__body">
          <div class="dw-thumb">
            ${thumbInner}
          </div>

          <div>
            <div style="font-weight:700;">${escapeHtml(c.title)}</div>
            ${getCardSizeLabel(c) ? `<div class="dw-card__variant">Card size: ${escapeHtml(getCardSizeLabel(c))}</div>` : ``}

            <div class="dw-card__meta">
              ${c.summary ? escapeHtml(c.summary) : 'No delivery details yet.'}
            </div>

            <div class="dw-card__actions" style="display:flex; gap:10px; flex-wrap:wrap;">
              <button class="dw-card__cta" type="button" data-cardid="${c.id}">
                ${ctaText}
              </button>

              ${msgBtnHtml}
            </div>
          </div>
        </div>
      `;
      cardsEl.appendChild(card);
    });

    // Custom card previews may still be rendering right after add-to-basket;
    // probe and swap them in when ready (mirrors the basket preview poll).
    cardsEl.querySelectorAll('img[data-cyoc-preview]').forEach(function (img) {
      cyocPollPreview(img, img.getAttribute('data-cyoc-preview'));
    });

    // Delivery details CTA
    cardsEl.querySelectorAll('.dw-card__cta').forEach(btn => {
      btn.addEventListener('click', () => {
        currentState = loadState() || currentState;

        const id = btn.dataset.cardid;
        const card = currentState && currentState.cards
          ? currentState.cards.find(x => x.id === id)
          : null;

        if (!card) return;

        const allowSendToMe = allowSendToMeForState(currentState);
        const applyToAll = isSharedSingleAddressMode(currentState);
        openEditor(card, { allowSendToMe, applyToAll });
      });
    });

    // Message CTA (routes to personalise page)
    cardsEl.querySelectorAll('.dw-card__msg').forEach(btn => {
      btn.addEventListener('click', () => {
        currentState = loadState() || currentState;

        const id = btn.dataset.cardid;
        const card = currentState && currentState.cards
          ? currentState.cards.find(x => x.id === id)
          : null;

        if (!card) return;

        goToPersonalise(card);
      });
    });
  }

  function showDashboard(state) {
    updateQuestionTextForState(state);
    updateModeSelectionUI(state && state.mode);

    setModeSelectionVisible(!isSingleCardState(state) && !isAllPacksState(state));

    if (dashboardEl) dashboardEl.hidden = false;

    renderCards(state);
    updateFooter(state);
  }

  function scrollToDashboardHeading() {
    const target = dashboardQuestionEl || dashboardEl;

    if (!target) return;

    requestAnimationFrame(() => {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  }

  function restoreDashboardScrollIfRequested() {
    let shouldScroll = false;

    try {
      shouldScroll =
        localStorage.getItem(LS.SCROLL_TO_DASHBOARD) === 'true';

      localStorage.removeItem(LS.SCROLL_TO_DASHBOARD);
    } catch (e) {}

    if (shouldScroll) {
      scrollToDashboardHeading();
    }
  }

  function updateModeSelectionUI(mode) {
    if (!mainEl) return;

    mainEl.querySelectorAll('.dw-mode').forEach(btn => {
      const isSelected = btn.dataset.mode === mode;

      btn.classList.toggle('is-selected', isSelected);
      btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });
  }

  function setSelectedMode(mode) {
    const state = currentState;

    const buttons = mainEl.querySelectorAll('.dw-mode');
    buttons.forEach(btn => {
      const isSel = btn.dataset.mode === mode;
      btn.classList.toggle('is-selected', isSel);
      btn.setAttribute('aria-pressed', isSel ? 'true' : 'false');
    });

    state.mode = mode;
    saveState(state);
    currentState = loadState() || state;
    updateQuestionTextForState(currentState);

  if (mode === 'multi') {
    showDashboard(currentState);
    scrollToDashboardHeading();
    return;
  }

    if (mode === 'single') {
      showDashboard(currentState);

      if (currentState.cards && currentState.cards.length > 1) {
        const targetCard = currentState.cards.find(c => !c.complete) || currentState.cards[0];
        if (targetCard) {
          openEditor(targetCard, {
            allowSendToMe: allowSendToMeForState(currentState),
            applyToAll: true
          });
        }
      }
      return;
    }

    showModeSelection(currentState);
  }

  // NEW: refresh when returning from /pages/personalise (bfcache-safe)
  async function refreshFromCartIfVisible() {
    try {
      if (!mainEl || mainEl.hidden) return;

      let cart = await getCart();
      if (!cart.items || cart.items.length === 0) return;

      cart = await normaliseCartIfNeeded(cart);

      currentState = loadState() || currentState;

      if (
        !currentState ||
        !currentState.version ||
        !savedStateMatchesCurrentCart(currentState, cart)
      ) {
        currentState = initStateFromCart(cart);
      } else {
        currentState = syncStateWithCart(currentState, cart);
      }
      
      currentState = normaliseStateDeliveryMethods(currentState);
      currentState = reconcileModeWithCardCount(currentState);
      saveState(currentState);
      currentState = loadState() || currentState;

      preloadSavedAddresses();

  if (isSingleCardState(currentState)) {
    startSingleCardFlow(currentState, { autoOpenIfIncomplete: true });
  } else if (
    currentState.mode === 'single' ||
    currentState.mode === 'multi'
  ) {
    // Preserve the customer's chosen delivery mode when returning
    // from the personalisation page, even if no delivery card is
    // complete yet.
    showDashboard(currentState);
    restoreDashboardScrollIfRequested();

  } else {
    showModeSelection(currentState);
  }

    } catch (e) {}
  }

  window.addEventListener('pageshow', () => {
    refreshFromCartIfVisible();
  });

  try {
    let cart = await getCart();

    if ((!cart.items || cart.items.length === 0) && listLineSummary.count > 0) {
      window.location.replace('/checkout');
      return;
    }

    if (!cart.items || cart.items.length === 0) {
      try {
        localStorage.removeItem(STATE_KEY);
        localStorage.removeItem(LS.SCROLL_TO_DASHBOARD);
        sessionStorage.removeItem(NORMALISE_KEY);
      } catch (e) {}

      currentState = null;
      loadingEl.hidden = true;
      emptyEl.hidden = false;
      return;
    }

    cart = await normaliseCartIfNeeded(cart);

    currentState = loadState();

    if (
      !currentState ||
      !currentState.version ||
      !savedStateMatchesCurrentCart(currentState, cart)
    ) {
      // This is a new basket, so do not carry across the previous
      // basket's Single / Multiple address choice or delivery state.
      currentState = initStateFromCart(cart);
    } else {
      currentState = syncStateWithCart(currentState, cart);
    }

    currentState = normaliseStateDeliveryMethods(currentState);
    currentState = reconcileModeWithCardCount(currentState);
    saveState(currentState);
    currentState = loadState() || currentState;

    preloadSavedAddresses();

    loadingEl.hidden = true;
    mainEl.hidden = false;
    showListNotice();

    refreshDeliveryMethodSelect();
    bindEditorEventsOnce();
    bindMessageGateEventsOnce();

    mainEl.querySelectorAll('.dw-mode').forEach(btn => {
      btn.addEventListener('click', () => setSelectedMode(btn.dataset.mode));
    });

    if (isSingleCardState(currentState)) {
      startSingleCardFlow(currentState, { autoOpenIfIncomplete: true });
    } else if (
      currentState.mode === 'single' ||
      currentState.mode === 'multi'
    ) {
      showDashboard(currentState);
      restoreDashboardScrollIfRequested();
    } else {
      showModeSelection(currentState);
    }

    continueBtn.addEventListener('click', () => {
      const action = continueBtn.dataset.action;
      if (!action) return;
      handleProceed(action);
    });

  } catch (err) {
    console.error('Gigglz delivery wizard initialisation failed:', err);

    if (loadingEl) {
      loadingEl.textContent = 'Something went wrong loading your basket.';
    }
  }
});